module.exports = __webpack_public_path__ + "static/media/samsung-galaxy-note5-5.40a921fb.jpg";